import { Button } from '@/components/ui/button';
import { toaster } from '@/components/ui/toast';
import { userId } from '@state/auth';
import { useCalendarState } from '@state/events/calendar-state';
import { useMutation } from '@tanstack/solid-query';
import { Trash } from 'lucide-solid'; // Assuming you are using lucide-solid for icons
import { useService } from 'solid-services';
import { queryClient } from 'src/App';
import { deleteEvent } from './api';

export default function DeleteEventButton() {
  // Pull the active event and setter from your state
  const { activeEvent, setActiveEvent } = useService(useCalendarState)();

  const mutation = useMutation(() => ({
    mutationFn: async () => {
      const event = activeEvent();
      if (!event?.id) {
        throw new Error('No active event selected to delete.');
      }
      return deleteEvent(event.id);
    },
    onSuccess: () => {
      toaster.create({
        title: 'Event deleted',
        type: 'success',
      });
      // Refresh the events list
      queryClient.invalidateQueries({ queryKey: ['events', userId()] });

      // Clear the active event from state since it no longer exists
      if (setActiveEvent) {
        setActiveEvent(undefined);
      }
    },
    onError: (error) => {
      toaster.create({
        title: 'Error deleting event',
        description: error.message,
        type: 'error',
      });
    },
  }));

  return (
    <Button
      colorPalette="red"
      variant="solid"
      loading={mutation.isPending}
      onClick={() => mutation.mutate()}
    >
      <Trash />
      Delete
    </Button>
  );
}
